export default __webpack_public_path__ + "static/media/brave.5f6e9e6b.png";